// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_82e3db2ea0--wrap--Yq45N","resize-children":"_82e3db2ea0--resize-children--Nil5H"};